import React, { useMemo } from "react";
import "../css/GroomingServiceCard.css";

const GroomingServiceCard = ({ data = [] }) => {
  // 🔍 Find the "Grooming" service object
  const groomingData = useMemo(
    () => data.find((item) => item.service === "Grooming"),
    [data]
  );

  // 🧮 Safely extract values (fallbacks for missing data)
  const totalServices = groomingData?.overall_grooming_services || 0;
  const totalRevenue = groomingData?.overall_grooming_service_revenue || 0;
  const ongoingCount = groomingData?.ongoing_service || 0;
  const pendingCount = groomingData?.pending_service || 0;
  const completedCount = groomingData?.completed_service || 0;
  const bestPartner = groomingData?.best_grooming_partner || "N/A";

  return (
    <div className="grooming-card">
      <div className="grooming-title">Grooming</div>
      <div className="grooming-content">
        <div className="grooming-row">
          <span className="grooming-label">Overall Grooming Services</span>
          <span className="grooming-colon">:</span>
          <span className="grooming-value">{totalServices}</span>
        </div>

        <div className="grooming-row">
          <span className="grooming-label">
            Overall Grooming Service Revenue
          </span>
          <span className="grooming-colon">:</span>
          <span className="grooming-value">
            ₹{totalRevenue.toLocaleString()}
          </span>
        </div>

        <div className="grooming-row">
          <span className="grooming-label">Ongoing Service</span>
          <span className="grooming-colon">:</span>
          <span className="grooming-value">{ongoingCount}</span>
        </div>

        <div className="grooming-row">
          <span className="grooming-label">Pending Service</span>
          <span className="grooming-colon">:</span>
          <span className="grooming-value">{pendingCount}</span>
        </div>

        <div className="grooming-row">
          <span className="grooming-label">Completed Service</span>
          <span className="grooming-colon">:</span>
          <span className="grooming-value">{completedCount}</span>
        </div>

        <div className="grooming-row">
          <span className="grooming-label">Best Grooming Partner</span>
          <span className="grooming-colon">:</span>
          <span className="grooming-value">{bestPartner}</span>
        </div>
      </div>
    </div>
  );
};

export default GroomingServiceCard;
